import ConflictingSwitches from './ConflictingSwitches'
export default ConflictingSwitches